import React, { useState } from "react";
import Axios from "axios"
import ReCAPTCHA from "react-google-recaptcha";

const ContactUs = () => {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const GOOGLE_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA;

    //console.log(GOOGLE_RECAPTCHA_SITE_KEY);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        }
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is invalid";
        }
        if (!formData.message.trim()) {
            newErrors.message = "Message is required";
        }

        if (!captchaVerified) {
            newErrors.captcha = "Please verify the CAPTCHA";
        }

        return newErrors;
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleCaptchaChange = (value) => {
        setCaptchaVerified(!!value); // Set true if captcha is successfully verified
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length === 0) {
            setLoading(true);
            try {
                const URL = process.env.REACT_APP_BACKENDURL;

                // Prepare form data
                const formDataToSend = new FormData();
                formDataToSend.append('name', formData.name);
                formDataToSend.append('email', formData.email);
                formDataToSend.append('message', formData.message);
                formDataToSend.append('request', 'contactUs');
                formDataToSend.append('action', 'contactUs');

                // Optional: If you're verifying reCAPTCHA server-side, include the token
                formDataToSend.append('recaptcha_token', captchaVerified);

                // Send the POST request
                const response = await Axios.post(URL, formDataToSend, {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Important for FormData
                    },
                    withCredentials: true, // Include credentials (cookies) if necessary
                });

                if (response.status === 200) {
                    console.log("Form submitted successfully:", response.data);
                    setSubmitted(true);
                    setFormData({ name: "", email: "", message: "" }); // Clear the form
                } else {
                    console.error("Error submitting form:", response.data);
                }
            } catch (error) {
                console.error("Error submitting form:", error);
            }
        } else {
            setErrors(formErrors);
            setSubmitted(false);
        }

        setLoading(false);
    };


    return (
        <div className="container contact-us" style={{ color: '#EEEEF0' }}>
            <h1 className="text-center mb-4">Contact Us</h1>
            <div className="row">
                {/* Left Column - Text */}
                <div className="col-md-6 mb-4">
                    <h3>Get in Touch</h3>
                    <p>
                        We’d love to hear from you! If you have any questions, feedback, or
                        need assistance, feel free to reach out. Our team is here to help.
                    </p>

                    <ul className="list-unstyled">
                        <li>
                            <strong>Email:</strong> support@goldcleats.com
                        </li>

                        <li>
                            <strong>Address:</strong> United States of America<br />
                            4112 Lee Highway,<br /> Arlington,<br />
                            VA, United States
                        </li>
                    </ul>
                    <p>
                        We aim to respond to all inquiries within 24 hours. Thank you for
                        reaching out to us!
                    </p>
                </div>

                {/* Right Column - Form */}
                <div className="col-md-6">
                    <h3>Send Us a Message</h3>
                    {submitted && (
                        <div className="alert alert-success">
                            Thank you for your message! We will get back to you soon.
                        </div>
                    )}
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                id="name"
                                placeholder="Enter your name"
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <input
                                type="email"
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                id="email"
                                placeholder="Enter your email"
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="message" className="form-label">
                                Message
                            </label>
                            <textarea
                                className={`form-control ${errors.message ? "is-invalid" : ""}`}
                                id="message"
                                rows="4"
                                placeholder="Write your message"
                                value={formData.message}
                                onChange={handleInputChange}
                            ></textarea>
                            {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                        </div>

                        {/* CAPTCHA */}
                        <div className="mb-3">
                            <ReCAPTCHA
                                sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                                onChange={handleCaptchaChange}
                            />
                            {errors.captcha && <div className="text-danger">{errors.captcha}</div>}
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="submit" className="btn btn-login btn-primary">
                                {isLoading ? 'Sending...' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
